/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $CustomerCreate = {
    properties: {
        firstName: {
            type: 'string',
            isNullable: true,
        },
        lastName: {
            type: 'string',
            isNullable: true,
        },
        fullName: {
            type: 'string',
            isRequired: true,
            minLength: 1,
        },
        email: {
            type: 'string',
            isNullable: true,
        },
        homePhone: {
            type: 'string',
            isRequired: true,
            minLength: 1,
        },
        workPhone: {
            type: 'string',
            isNullable: true,
        },
        cellPhone: {
            type: 'string',
            isNullable: true,
        },
        street: {
            type: 'string',
            isRequired: true,
            minLength: 1,
        },
        street2: {
            type: 'string',
            isNullable: true,
        },
        city: {
            type: 'string',
            isRequired: true,
            minLength: 1,
        },
        state: {
            type: 'string',
            isRequired: true,
            maxLength: 2,
            minLength: 2,
        },
        zip: {
            type: 'string',
            isRequired: true,
            maxLength: 10,
            minLength: 5,
        },
        zip4: {
            type: 'string',
            isNullable: true,
            maxLength: 4,
            minLength: 4,
        },
    },
};